import { HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { IApiResponse } from "../core/models/api-response.model";
import { AppConfig } from "../design/app";
import { IAppConfig } from "../core/models/app-config.model";
import { Subscription } from '../models/subscription';
import { OpenSubscriptionPricingInformation } from '../models/open-subscription-pricing-information';
import { SubscriptionAdmin } from '../models/subscription-admin'
import { Company } from "../models/company";
import { PPMD } from "../models/ppmd";
import { Coordinator } from "../models/coordinator";
import { AssignSessionsToSubsInputDTO } from "../models/assign-session-subscription-model";
const urlsStartPoint = "";

const Urls: Array<string> = [
  `${urlsStartPoint}/api/CreateSession/GetCompanies?searchword={term}&count=1`,
  `${urlsStartPoint}api/Subscription/GetSubscriptionAdmins?searchword={term}`,
  `${urlsStartPoint}api/CreateSession/AllCoordinators?count=10&searchText={term}`
];

@Injectable({
  providedIn: "root",
})

export class AddSubscription {
  public editSubscriptionResponse: Subscription;
  private appConfig: any;

  constructor(private http: HttpClient) {
    this.appConfig = AppConfig;
  }

  submitData(data: any): Observable<number[]> {
    const baseUrl = this.appConfig.subscription.baseUrl;
    const saveOrUpdateSubscription = this.appConfig.subscription.saveOrUpdateSubscription;
    const url = `${baseUrl + saveOrUpdateSubscription}`;
    return this.http.post<IApiResponse<number[]>>(url, data).pipe(
      map((res) => {
        if (res.Data) {
          return res.Data;
        }
        return null;
      })
    );
  }
  

  getEditSubscription(subscriptionId): Observable<Subscription> {
    const baseUrl = this.appConfig.subscription.baseUrl;
    const getEditSubscription = this.appConfig.subscription.getEditSubscription;
    const url = `${baseUrl + getEditSubscription + '?subscriptionID=' + subscriptionId}`;
    return this.http.get<IApiResponse<Subscription>>(url).pipe(
      map((res) => {
        return res.Data;
      }),
      catchError(this.handleError)
    );
  }


  getCompanies(term: string, target: number): Observable<Company[]> {
    if (term === "" || term.length <= 2) {
      return of([]);
    }

    const baseUrl = this.appConfig.session.baseUrl;
    const getCompanies = this.appConfig.session.getCompanies;
    const url = `${baseUrl + getCompanies}`;
    const count = this.appConfig.searchCount ? this.appConfig.searchCount : "15";
    const request = {
      CompanyName: term,
      Count: count
    }

    return this.http.post<IApiResponse<Company[]>>(url, request).pipe(
      map((res) => res.Data),
      catchError(this.handleError)
    );
  }
  
  public getPPMDs(term: string, target: number): Observable<PPMD[]> {
    if (term === "" || term.length <= 2) {
      return of([]);
    }

    const baseUrl = this.appConfig.session.baseUrl;
    const getSubscriptionAdmins = this.appConfig.session.getPPMDs;
    const url = `${baseUrl + getSubscriptionAdmins + '?searchText=' + term}`;

    return this.http.get<IApiResponse<PPMD[]>>(url).pipe(
      map((res) => res.Data),
      catchError(this.handleError)
    );
  }

  public searchAdminData(term: string, target: number): Observable<SubscriptionAdmin[]> {
    if (term === "" || term.length <= 2) {
      return of([]);
    }

    const baseUrl = this.appConfig.subscription.baseUrl;
    const getSubscriptionAdmins = this.appConfig.subscription.getSubscriptionAdmins;
    const url = `${baseUrl + getSubscriptionAdmins + '?SearchWord=' + term}`;

    return this.http.get<IApiResponse<SubscriptionAdmin[]>>(url).pipe(
      map((res) => res.Data),
      catchError(this.handleError)
    );
  }

  getRoles(term: string, isFacilitator: boolean): Observable<Coordinator[]> {
    if (term === "" || term.length <= 2) {
      return of([]);
    }
    const count = this.appConfig.searchCount ? this.appConfig.searchCount : "15";
    const request = {
      Count: count,
      SearchText: term,
      IsFacilitatorClientCertified: isFacilitator
    }

    const baseUrl = this.appConfig.subscription.baseUrl;
    const getAdminRoles = this.appConfig.subscription.getAdminRoles;
    const url = `${baseUrl + getAdminRoles}`;

    return this.http.post<IApiResponse<Coordinator[]>>(url, request).pipe(
      map((res) => res.Data),
      catchError(this.handleError)
    );

  }

  getPricingInformation(request): Observable<OpenSubscriptionPricingInformation[]> {
    const baseUrl = this.appConfig.subscription.baseUrl;
    const getOpenSubscriptionPricingInformationDetails = this.appConfig.subscription.getOpenSubscriptionPricingInformationDetails;
    const url = `${baseUrl + getOpenSubscriptionPricingInformationDetails}`;
    return this.http.post<IApiResponse<OpenSubscriptionPricingInformation[]>>(url, request).pipe(
      map((res) => res.Data),
      catchError(this.handleError)
    );
  }
 

    getSessionsForSubAssociation(company: string, subscriptionID: number): Observable<IApiResponse<any>> {
      const baseUrl = this.appConfig.session.baseUrl;
      const getSessionsForSubAssociation = this.appConfig.session.getSessionsForSubAssociation;
      const url = `${baseUrl + getSessionsForSubAssociation}?company=${company}&subscriptionID=${subscriptionID}`;

      return this.http.get<IApiResponse<any>>(url).pipe(
        map((res) => res),
        catchError(this.handleError)
      );
  }
  assignSessionsToSubscription(sessionsList: AssignSessionsToSubsInputDTO): Observable<any> {
    const baseUrl = this.appConfig.session.baseUrl;
    const assignSessionsForSubAssociation = this.appConfig.session.assignSessionsForSubAssociation;
    const url = baseUrl + assignSessionsForSubAssociation
    return this.http.post<IApiResponse<AssignSessionsToSubsInputDTO[]>>(url, sessionsList).pipe(
      map((res) => res),
      catchError(this.handleError)
    );
  }
    emailDownload(addSession: any, subjectName): Observable<any> {
    const baseUrl = this.appConfig.subscription.baseUrl;
    const CreateAcknolwedgementEmail = this.appConfig.subscription.downloadAcknowledgement;
    const apiUrl = `${baseUrl + CreateAcknolwedgementEmail}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    const criteria = JSON.stringify(addSession);
    return this.http.post(apiUrl + subjectName, criteria, {headers, responseType: 'arraybuffer' }).pipe(
      map(response => { 
        return new Uint8Array(response);
      }),
      catchError(this.handleError)
    );

  }
  getSubDomains(): Observable<IApiResponse<string[]>> {
    const baseUrl = this.appConfig.subscription.mainbaseUrl;
    const getSubDomainsUrl = this.appConfig.subscription.getSubDomains;
    const url = baseUrl + getSubDomainsUrl;
    //return this.httpClientService.get<IApiResponse<string[]>>(url);
    return this.http.get<any>(url).pipe(
      map((res) => {
        // Transform the API response to match the IApiResponse interface
        return {
          Success: res.success, // Map `success` to `Success`
          Data: res.data,       // Map `data` to `Data`
        } as IApiResponse<string[]>;
      }),
      catchError(this.handleError)
    );
  }

  // Get WBS Codes for typeahead dropdown
  getWBSCodes(searchText: string): Observable<any[]> {
    if (!searchText || searchText.length < 22) {
      return of([]);
    }
    const baseUrl = this.appConfig.session.baseUrl;
    const GetWBSCodes = this.appConfig.session.GetWBSCodes;
    const apiUrl = `${baseUrl + GetWBSCodes}?searchText=${encodeURIComponent(searchText)}`;
    return this.http.get<IApiResponse<any>>(apiUrl).pipe(
      map((response) => {
        // Extract WbsElements from nested response structure
        const wbsElements = response.Data?.Wbs?.WbsElements;
        return wbsElements ? [wbsElements] : [];
      }),
      catchError(() => of([]))
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("An error occurred:", error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return throwError("Something bad happened; please try again later.");
  }
}
